import { ScreeningAnswer, ScreeningTemplateType } from "@prisma/client"
import { sortQuestionsByPositionAndAnswers } from "utils/sorting"
import { useCurrentPreferences } from "store/hooks"
import { useTranslation } from "react-i18next"
import { getQuestionResponseComponent } from "./getQuestionResponseComponent"

const buildIntakeFormResponse = (
    questions: any,
    screeningAnswers: ScreeningAnswer[],
    useQuestionnaireView: boolean = false,
    screeningType?: ScreeningTemplateType
) => {
    const sortedQuestions = sortQuestionsByPositionAndAnswers(questions, screeningAnswers)
    const dateFormat = useCurrentPreferences()?.date_format
    const { i18n } = useTranslation("common")

    return sortedQuestions.map((question: any, index: number) => {
        const screeningAnswer = screeningAnswers.find((answer) => answer.screening_template_question_id === question.id)

        return (
            <div key={`question_${index}`} className="p-4 bg-white rounded-lg shadow-sm">
                {getQuestionResponseComponent(
                    question,
                    screeningAnswer,
                    index,
                    dateFormat,
                    i18n,
                    screeningAnswers,
                    useQuestionnaireView,
                    screeningType
                )}
            </div>
        )
    })
}

export default buildIntakeFormResponse
